import React from "react"
import PropTypes from "prop-types"
import { navigate } from "gatsby"
import {Consumer} from "../../libs/AuthContext"

const querystring = (name, url = window.location.href) => {
  name = name.replace(/[[]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const Unauthenticated = ({ component: Component, location, ...rest }) =>{
  let redirect = querystring("redirect")
  if (redirect === "" || redirect === null) {
    redirect = "/"
  }
  return (
  <Consumer>
  {context =>
        !context.isAuthenticated
          ? <Component {...rest} />
          : navigate(redirect)
  }
  </Consumer>
  )
}


Unauthenticated.propTypes = {
  component: PropTypes.any.isRequired,
}

export default Unauthenticated
